import { MapPin, Clock, Phone, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer
            id="contact"
            className="relative bg-lpl-primary-deep text-lpl-bg overflow-hidden"
            data-testid="footer"
        >
            <div className="relative max-w-7xl mx-auto px-5 md:px-10 pt-24 pb-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
                    <div className="lg:col-span-7">
                        <h2
                            className="font-display font-semibold text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tight"
                            data-testid="footer-title"
                        >
                            Bourg-en
                            <br />
                            <span className="font-serif italic font-normal text-lpl-yellow">
                                Bresse
                            </span>
                            <span className="text-lpl-lavender">.</span>
                        </h2>
                    </div>

                    <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-7 text-sm">
                        <div>
                            <div className="flex items-center gap-2 mb-2 opacity-80">
                                <MapPin size={16} />
                                <span className="uppercase tracking-[0.16em] text-xs font-semibold">
                                    Adresse
                                </span>
                            </div>
                            <p className="text-lg leading-snug">
                                La Petite Lunetterie
                                <br />
                                7 place Edgar Quinet
                                <br />
                                <span className="opacity-70">
                                    01000 Bourg-en-Bresse
                                </span>
                            </p>
                        </div>

                        <div>
                            <div className="flex items-center gap-2 mb-2 opacity-80">
                                <Clock size={16} />
                                <span className="uppercase tracking-[0.16em] text-xs font-semibold">
                                    Horaires
                                </span>
                            </div>
                            <p className="text-base leading-snug">
                                Mar – Ven : 9h30 – 12h30 / 14h – 19h
                                <br />
                                Samedi : 9h30 – 12h30 / 14h – 18h
                                <br />
                                <span className="opacity-70">
                                    Dim &amp; Lun : fermé
                                </span>
                            </p>
                        </div>

                        <div>
                            <div className="flex items-center gap-2 mb-2 opacity-80">
                                <Phone size={16} />
                                <span className="uppercase tracking-[0.16em] text-xs font-semibold">
                                    Téléphone
                                </span>
                            </div>
                            <a
                                href="tel:+33474227144"
                                data-testid="footer-phone"
                                className="text-lg hover:text-lpl-yellow transition-colors"
                            >
                                04 74 22 71 44
                            </a>
                        </div>

                        <div>
                            <div className="flex items-center gap-2 mb-2 opacity-80">
                                <Mail size={16} />
                                <span className="uppercase tracking-[0.16em] text-xs font-semibold">
                                    Email
                                </span>
                            </div>
                            <a
                                href="mailto:contact@lapetitelunetterie.fr"
                                data-testid="footer-email"
                                className="text-sm md:text-base hover:text-lpl-yellow transition-colors whitespace-nowrap"
                            >
                                contact@lapetitelunetterie.fr
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-lpl-bg/20 pt-8 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm items-center">
                    <p className="opacity-80 md:text-left text-center">
                        © {new Date().getFullYear()} La Petite Lunetterie
                        · Tous droits réservés
                    </p>
                    <p className="md:text-center text-center flex flex-col md:flex-row gap-1 md:gap-4 items-center justify-center">
                        <a
                            href="/mentions-legales"
                            data-testid="footer-mentions"
                            className="hover:text-lpl-yellow transition-colors underline-offset-4 hover:underline"
                        >
                            Mentions légales
                        </a>
                        <span aria-hidden className="hidden md:inline opacity-40">·</span>
                        <a
                            href="/politique-de-confidentialite"
                            data-testid="footer-confidentialite"
                            className="hover:text-lpl-yellow transition-colors underline-offset-4 hover:underline"
                        >
                            Politique de confidentialité
                        </a>
                    </p>
                    <p className="md:text-right text-center opacity-80">
                        Site conçu et réalisé par{" "}
                        <a
                            href="https://axeris-labs.fr"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-axeris"
                            className="text-lpl-yellow hover:underline underline-offset-4 font-semibold"
                        >
                            Axeris Labs
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
